import { dataHooks } from '@wix/data-hooks';

export const templatesPageDataHooks = dataHooks<{
  container: {};
}>('templates-page');
